var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item incr-tene"},[_c('x-angleIcon'),_vm._m(0),_c('div',{staticClass:"tenment",attrs:{"id":"tenment"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_c('i',{staticClass:"iconfont iconicon_jiantou"}),_vm._v("新增住户趋势图")])
}]

export { render, staticRenderFns }